import script from "./OCaracteristicaValorLista.vue?vue&type=script&lang=ts&setup=true"
export * from "./OCaracteristicaValorLista.vue?vue&type=script&lang=ts&setup=true"

import "./OCaracteristicaValorLista.vue?vue&type=style&index=0&id=cd5adc3a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd5adc3a"]])

export default __exports__